import React from "react";
import "./choose.css";

const WeHelpSection = () => {
  return (
    <div className="we-help-section">
      <div className="container">
        <div className="row justify-content-between">
          
          {/* Left Images */}
          <div className="col-lg-7 mb-5 mb-lg-0">
            <div className="imgs-grid">
              <div className="grid grid-1">
                <img src="/images/wood.png" alt="img1" />
              </div>
              <div className="grid grid-2">
                <img src="/images/factory.png" alt="img2" />
              </div>
              <div className="grid grid-3">
                <img src="/images/machines.png" alt="img3" />
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-5 ps-lg-5">
            <h2 className="section-title mb-4">
              Paab Furniture Manufacturing Company
            </h2>

            <p>
              PAAB furniture is a private limited company established in2023 with the aim of providing world class furniture to the Indian market and to tap the vast potential of the exportmarket.
            </p>

            <ul className="list-unstyled custom-list my-4">
              <li>The factory is in the industrial hub of Sector 80, Noida,Uttar Pradesh, near the Yamuna Expressway and theupcoming Jewar Airport. The locational advantage will beinstrumental in the expansion plans of PAAB.</li>
              <li>With our technical knowledge and industry experience, we pride ourselves as a valuable partner to our clients inproduct development and manufacturing for the intendedend-use.</li>
              <li>At PAAB, we develop in-house designs, and our continued investment in state-of-the-art equipment and digital
technology enables our team to meet and exceed customerrequirements.</li>
              <li>" Our factory tour provided valuable insights into the manufacturing process and showcased cutting-edge technology in action. Got a firsthand glimpse of how raw materials transform into finished brilliance. Pretty cool to see industry in motion!"</li>
            </ul>

            <p>
               <button className="btn btn-primary explore-btn">
  Explore
</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeHelpSection;